var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.7188 9C17.7188 4.18359 13.8164 0.28125 9 0.28125C4.18359 0.28125 0.28125 4.18359 0.28125 9C0.28125 13.3516 3.46957 16.9587 7.6377 17.6133V11.5204H5.42285V9H7.6377V7.07906C7.6377 4.8941 8.93848 3.68719 10.9308 3.68719C11.8849 3.68719 12.8827 3.85734 12.8827 3.85734V6.00188H11.783C10.7002 6.00188 10.3623 6.67406 10.3623 7.36348V9H12.7804L12.3936 11.5204H10.3623V17.6133C14.5304 16.9587 17.7188 13.3516 17.7188 9Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
